import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import OcTurbineIcon from "src/themes/assets/oc-turbine.svg?react";
import { LoadingMessage } from "../LoadingMessage/LoadingMessage";
import classNames from "classnames";
import { alpha } from "@mui/material/styles";
import { Box, Theme, useTheme } from "@mui/material";
import { keyframes } from "@emotion/react";

interface ISpinnerProps {
  loading?: boolean;
  message?: string;
  fullscreen?: boolean;
  dialogProps?: any;
  backgroundColor?: string;
  parent?: any; // HTMLElement;
  className?: string;
}

export const SpinnerProgress = (props: ISpinnerProps): JSX.Element => {
  const { loading, message, fullscreen, dialogProps, backgroundColor, parent, className } = props;
  const theme = useTheme();

  const rotationAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

  const SpinnerProgressStyles = (theme: Theme): any => ({
    progress: {
      margin: "16px",
    },
    loadingSpinner: {
      "& svg": {
        height: "60px",
        animation: `${rotationAnimation} 4s linear infinite`,
      },
    },
    modal_paper: {
      maxWidth: "none",
      maxHeight: "none",
      background: "none",
      boxShadow: "none",
    },
    fullscreen: {
      display: "flex",
      padding: "0 !important",
      alignItems: "center",
      overflow: "hidden",
      "& p": { margin: "0 0 0 10px" },
    },
    embedded: {
      display: "flex",
      padding: "0 !important",
      justifyContent: "center",
      overflow: "hidden",
      alignItems: "center",
      boxSizing: "border-box",
      position: "relative",
      zIndex: 400,
      width: "100%",
      height: "100%",
      "& p": { margin: "0 0 0 10px" },
    },
  });

  // When using embedded mode, the parent component must have a position set to 'relative'
  // in order for the spinner's height and width assignments to work correctly.
  return !fullscreen && loading ? (
    <DialogContent
      className={classNames("dialog_spinner_progress", className ? className : "")}
      sx={(theme) => SpinnerProgressStyles(theme).embedded}
    >
      <Box sx={(theme) => SpinnerProgressStyles(theme).loadingSpinner}>
        <OcTurbineIcon className={classNames("oc_spinner")} />
      </Box>
      <DialogContentText className="spinner_message">
        <LoadingMessage message={message} />
      </DialogContentText>
    </DialogContent>
  ) : fullscreen && loading ? (
    <Dialog
      className={classNames("dialog_spinner_progress", className ? className : "")}
      classes={{ paper: SpinnerProgressStyles(theme).modal_paper }}
      open={loading}
      {...dialogProps}
    >
      <DialogContent className={SpinnerProgressStyles(theme).fullscreen}>
        <Box sx={(theme) => SpinnerProgressStyles(theme).loadingSpinner}>
          <OcTurbineIcon className={classNames("oc_spinner")} />
        </Box>
        <DialogContentText className="spinner_message">
          <LoadingMessage message={message} />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  ) : null;
};
